import { LogoTracker } from '~/lib/events/tracker'
import logger from '~/lib/logger'

export default function({ route }) {
  logger.debug('Initializing LogoTracker')

  if (route.query.internal_login) {
    logger.debug('Skipping LogoTracker initialization for SSO login')
    return
  }

  LogoTracker.init()
}
